import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ImmobilierService } from '../services/immobilier.service';
import { User } from '../models/user';
import { AddEditAgentDialogComponent } from './add-edit-agent-dialog/add-edit-agent-dialog.component';

@Component({
  selector: 'app-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.css']
})
export class AgentsComponent implements OnInit, AfterViewInit {

  displayedColumns: string[] = ['id', 'name', 'login', 'profile', 'status', 'actions'];
  dataSource: MatTableDataSource<User>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  searchText: string = '';
  // Mobile pagination
  pageSize = 5;
  currentPage = 0;

  constructor(
    private immobilierService: ImmobilierService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
    this.loadAgents();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.filterPredicate = (data: User, filter: string) => {
      const dataStr = (data.firstName + ' ' + data.lastName + ' ' + data.login + ' ' + data.profile).toLowerCase();
      return dataStr.indexOf(filter.trim().toLowerCase()) !== -1;
    };
  }

  loadAgents(): void {
    this.immobilierService.getUsers().subscribe({
      next: (users) => {
        this.dataSource.data = users;
      },
      error: (error) => console.error('Erreur lors du chargement des agents:', error)
    });
  }

  applyFilter() {
    this.dataSource.filter = this.searchText.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onPageChange(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
  }

  openAddDialog(): void {
    const dialogRef = this.dialog.open(AddEditAgentDialogComponent, {
      width: '600px',
      data: { isNew: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadAgents();
      }
    });
  }

  openEditDialog(agent: User): void {
    const dialogRef = this.dialog.open(AddEditAgentDialogComponent, {
      width: '600px',
      data: { isNew: false, agent: agent }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadAgents();
      }
    });
  }

  deleteAgent(agent: User): void {
    if (confirm(`Voulez-vous vraiment supprimer l'agent ${agent.firstName} ${agent.lastName} ?`)) {
      this.immobilierService.deleteUser(agent.id!).subscribe({
        next: () => {
          this.snackBar.open('Agent supprimé avec succès', 'Fermer', { duration: 3000 });
          this.loadAgents();
        },
        error: (err) => {
          if (err.status === 400 && err.error && err.error.message) {
            this.snackBar.open(err.error.message, 'Fermer', { duration: 5000 });
          } else {
            this.snackBar.open('Erreur lors de la suppression', 'Fermer', { duration: 3000 });
          }
        }
      });
    }
  }

}
